













import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";

@Component({
	components: {
		CardTitle,
		DetailsDataTable
	}
})

export default class ListaAziende extends Vue {
	private titleParams: object;
	private dataTableParams: any;
	private contattiDataTableParams: any;
	private createDialogParams: object;

	private listaAziende: any;

	constructor() {
		super();
		this.titleParams = {
			title: "Elenco Aziende",
			cols: "12",
			sm: "5",
			md: "5",
			lg: "4"
		};
		this.dataTableParams = {
			headers: [],
			records: [],
			dialogParams: {
				title: "DETTAGLI AZIENDA",
				type: "enterpriseTab"
			},
			filterType: "listaAziende"
		};
		this.createDialogParams = {
			visible: false,
			type: ""
		};
	}

	loadEnterprisesList() {
		var userInfo = user.readUserInfo(this["$store"]);
		var payload = {
			idIstituto: 0
		};
		var instituteInfo = user.readInstituteInfo(this["$store"]);
		payload = {
			idIstituto: instituteInfo.id
		};
		data
			.dispatchEnterprisesList(this["$store"], payload)
			.then(result => {
				this.listaAziende = result;
				this.dataTableParams.records = result;
				bus.$emit("dataLoaded");
			})
			.catch(error => {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", "Errore nel caricamento lista azienda");
				}
			});
	}

	setTableColumns() {
		var userInfo = user.readUserInfo(this["$store"]);
		if (userInfo.ruoloUtente.includes(2)) {
			this.dataTableParams.headers = [
				{
					text: "Denominazione",
					value: "denominazioneAzienda"
				},
				{
					text: "E-Mail",
					value: "emailAzienda"
				},
				{
					text: "Verificato",
					value: "verificato",
					width: '1%'
				},
				{
					text: "Dettagli",
					value: "action",
					sortable: false,
					width: '1%'
				},
				{
					text: "Status Nomina",
					value: "reviewNominaResponsabile",
					sortable: false,
					width: '1%'
				},
				{
					text: "Storico Attività",
					value: "storicoAttivitaAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "Contatti",
					value: "contattiAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "Note",
					value: "noteAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "",
					value: "ratingAzienda",
					sortable: false,
					width: "1%"
				}
			]
		} else if (userInfo.ruoloUtente.includes(5)) {
			this.dataTableParams.headers = [
				{
					text: "Denominazione",
					value: "denominazioneAzienda"
				},
				{
					text: "E-Mail",
					value: "emailAzienda"
				},
				{
					text: "Dettagli",
					value: "action",
					sortable: false,
					width: '1%'
				},
				{
					text: "Storico Attività",
					value: "storicoAttivitaAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "Contatti",
					value: "contattiAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "Note",
					value: "noteAzienda",
					sortable: false,
					width: "1%"
				},
				{
					text: "",
					value: "ratingAzienda",
					sortable: false,
					width: "1%"
				}
			]
		}
		// else if(userInfo.ruoloUtente.includes(11)){
		//   this.dataTableParams.headers = [
		//     {
		//       text: "Denominazione",
		//       value: "denominazioneAzienda"
		//     },
		//     {
		//       text: "Indirizzo Azienda"
		//     },
		//     {
		//       text: "Telefono",
		//       value: "telefono1Azienda"
		//     },
		//     {
		//       text: "E-Mail",
		//       value: "emailAzienda"
		//     },
		//     {
		//       text: "Dettagli",
		//       value: "action",
		//       sortable: false,
		//       width: '1%'
		//     },
		//     {
		//       text: "Contatti",
		//       value: "contattiAzienda",
		//       sortable: false,
		//       width: "1%"
		//     }
		//   ]
		// }
	}

	created() {
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {
				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(() => {
						this.setTableColumns()
						this.loadEnterprisesList();
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});

		bus.$on("loadEnterprisesList", () => {
			this.loadEnterprisesList();
		});

		bus.$on("filtroAziende", (filters: any) => {
			const listaAziende: any = this.listaAziende;
			var tempList: any = [];
			this.dataTableParams.records = [];
			listaAziende.forEach((azienda: any) => {
				if (filters.filtroDocResp !== "Tutti") {
					if (filters.filtroDocResp === "Inviati") {
						if (azienda.idStatoDoc === 1) {
							tempList.push(azienda);
						}
					} else if (filters.filtroDocResp === "Eliminati") {
						if (azienda.idStatoDoc === 3) {
							tempList.push(azienda);
						}
					} else if (filters.filtroDocResp === "Confermati") {
						if (azienda.idStatoDoc === 2) {
							tempList.push(azienda);
						}
					}
				} else {
					tempList.push(azienda);
				}
			});
			this.dataTableParams.records = tempList;
		});
	}
}
